import { useEffect } from 'react';
import { activityAPI } from '../services/api';

const PING_INTERVAL_MS = 60 * 1000;

// Sends a lightweight "still active" heartbeat while the user is signed in and
// the tab is in the foreground. The server rolls these pings into sessions to
// measure time-on-app. Pauses when the tab is hidden (backgrounded / screen off)
// so we only count genuine foreground use, and fires once immediately on becoming
// visible so a returning user is registered without waiting a full interval.
export default function useActivityHeartbeat(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;

    const ping = () => {
      if (document.visibilityState === 'visible') {
        activityAPI.ping().catch(() => {}); // best-effort; never disrupt the UI
      }
    };

    ping(); // register the visit right away
    const timer = setInterval(ping, PING_INTERVAL_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') ping(); };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
}
